var p=function(p){return p+" 0px 0px 0px 0.5px"};export{p as g};
